import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRInput } from 'src/app/models/qr-input.model';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-dialog-change-password',
  templateUrl: './dialog-change-password.component.html',
  styleUrls: ['./dialog-change-password.component.scss'],
})
export class DialogChangePasswordComponent implements OnInit {
  //--------------------Inputs & Outputs--------------------
  @Input() value: LogedUser | undefined;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  //--------------------Variables--------------------

  visible: boolean = true;
  newPassword: string = '';
  oldPassword: string = '';
  repeatOldPassword: string = '';
  formData: any = new FormData();

  errors: {
    [key: string]: { error: boolean; message: string[] };
  } = {
    length: { error: true, message: ['Debe tener entre 8 y 12 caracteres.'] },
    caps: { error: false, message: ['Hace falta minimo 1 letra mayúscula.'] },
    number: { error: false, message: ['Hace falta minimo 1 número.'] },
    specChar: {
      error: false,
      message: ['No debe contener caracteres especiales.'],
    },
    userSimilar: { error: false, message: ['No debe ser igual al usuario.'] },
    notSimilar: { error: false, message: ['Las contraseñas no coinciden.'] },
  };

  //--------------------Inputs--------------------
  currentPasswordConfig: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    type: 'password',
    debounceTime: 250,
  };
  newPasswordConfig: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    type: 'password',
    debounceTime: 250,
  };
  repeatPasswordConfig: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    type: 'password',
    debounceTime: 250,
  };

  //--------------------Buttons--------------------
  buttonSubmitConfig: QRButton = {
    viewValue: 'Guardar',
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
  };
  buttonCancelConfig: QRButton = {
    viewValue: 'Cancelar',
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
  };

  ngOnInit(): void {
    this.change.emit('disabled');
  }

  currentPasswordChange(value: InputTypes): void {
    if (value) this.oldPassword = value.toString();
    this.validateFields();
  }

  newPasswordChange(value: InputTypes): void {
    if (value) {
      this.newPassword = value.toString();

      this.errors['length'].error = false;
      this.errors['caps'].error = false;
      this.errors['number'].error = false;
      this.errors['specChar'].error = false;
      this.errors['userSimilar'].error = false;

      if (this.newPassword) {
        const VALIDATIONS = [
          { key: 'length', isValid: this.isLengthValid(this.newPassword) },
          { key: 'caps', isValid: this.hasUpperCase(this.newPassword) },
          { key: 'number', isValid: this.hasNumber(this.newPassword) },
          { key: 'specChar', isValid: !this.hasSpecialChar(this.newPassword) },
          {
            key: 'userSimilar',
            isValid: this.isDifferentFromUsername(
              this.newPassword,
              this.value?.username ?? ''
            ),
          },
          {
            key: 'notSimilar',
            isValid: this.isSameAsOldPassword(
              this.newPassword,
              this.repeatOldPassword
            ),
          },
        ];
        VALIDATIONS.forEach(({ key, isValid }) => {
          this.errors[key].error = !isValid;
        });
      }
    }
    this.validateFields();
  }

  private isLengthValid(password: string): boolean {
    return password.length >= 8 && password.length <= 12;
  }

  private hasUpperCase(password: string): boolean {
    return /[A-Z]/.test(password);
  }

  private hasNumber(password: string): boolean {
    return /\d/.test(password);
  }

  private hasSpecialChar(password: string): boolean {
    return /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(password);
  }

  private isDifferentFromUsername(password: string, username: string): boolean {
    return password !== username;
  }

  private isSameAsOldPassword(password: string, oldPassword: string): boolean {
    return password === oldPassword;
  }

  repeatPasswordChange(value: InputTypes): void {
    if (value) {
      this.errors['notSimilar'].error = value != this.newPassword;
      if (value === this.newPassword) {
        this.repeatOldPassword = value;
      }
    }
    this.validateFields();
  }

  validateFields() {
    let result = true;
    Object.keys(this.errors).forEach((key: any) => {
      result = result && !this.errors[key].error;
    });
    if (!result) {
      this.change.emit('disabled');
    } else {
      const dto = {
        oldPass: this.oldPassword,
        newPass: this.newPassword,
        repetNewPass: this.repeatOldPassword,
      };
      this.change.emit(dto);
    }
  }

  //--------------------Buttons functions--------------------
  // save() {
  //   if (
  //     !this.errors['length'].error &&
  //     !this.errors['caps'].error &&
  //     !this.errors['number'].error &&
  //     !this.errors['specChar'].error &&
  //     !this.errors['userSimilar'].error
  //   ) {
  //     const dto = {
  //       user: this.value.username,
  //       userId: this.value.id,
  //       newPassword: this.newPassword
  //     }
  //     this.change.emit(dto);
  //   }
  // }
}
